import { useIntl } from 'react-intl';

export const useBagDisclosure = (props: UseBagDisclosureProps) => {
  const {
    orderChannel,
    showDeliveryFeeDisclosure,
    showOutpostPriceDifferenciationDisclosure,
    showDeliveryPriceDifferenciationDisclosure,
    deliveryMinSubtotal,
    deliveryFee,
    deliveryDisclosure,
    outpostDisclosure,
  } = props;

  const { formatNumber } = useIntl();

  if (
    orderChannel === 'delivery' &&
    showDeliveryPriceDifferenciationDisclosure &&
    showDeliveryFeeDisclosure
  ) {
    const minimum = formatNumber(deliveryMinSubtotal / 100, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    const fee = formatNumber(deliveryFee / 100, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    return deliveryDisclosure
      .replaceAll('{minimum}', minimum)
      .replaceAll('{fee}', fee);
  }

  if (orderChannel === 'outpost' && showOutpostPriceDifferenciationDisclosure) {
    return outpostDisclosure;
  }
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UseBagDisclosureProps = {
  orderChannel: 'pickup' | 'delivery' | 'outpost' | 'kiosk' | 'in-store';
  showDeliveryFeeDisclosure: boolean; // from restaurant/salesforce
  showOutpostPriceDifferenciationDisclosure: boolean; // from restaurant/salesforce
  showDeliveryPriceDifferenciationDisclosure: boolean; // from restaurant/salesforce
  deliveryMinSubtotal: number;
  deliveryFee: number;
  deliveryDisclosure: string;
  outpostDisclosure: string;
};
